module.exports = __webpack_public_path__ + "images/salesicon.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/salesicon.png
// module id = +576
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13